/**
 * The proposal to show after `currentId`, out of the ordered context list the
 * sidebar navigates (`contextProposalIds` from `ActionSidebarContext`):
 * the next one in the list, else the previous, else the first when the
 * current id is not in the list at all. `null` when there is nowhere to go.
 *
 * One definition shared by every proposal host that offers "next" navigation
 * (the portaled `ProposalSidebar` and the chat page's docked
 * `InlineProposalPanel`), so the two can never disagree about where "next"
 * lands.
 */
export function nextProposalId(
  contextProposalIds: readonly number[],
  currentId: number
): number | null {
  if (contextProposalIds.length === 0) {
    return null;
  }
  const currentIndex = contextProposalIds.indexOf(currentId);
  if (currentIndex === -1) {
    return contextProposalIds[0] ?? null;
  }
  // Try next in list
  if (currentIndex < contextProposalIds.length - 1) {
    return contextProposalIds[currentIndex + 1] ?? null;
  }
  // Fall back to previous
  if (currentIndex > 0) {
    return contextProposalIds[currentIndex - 1] ?? null;
  }
  return null;
}
